import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ListGroup, Dropdown } from 'react-bootstrap'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { history } from '../router/route';
import { Icon } from './Icon'

const Wrapper = styled.div`
  text-align:center;
  position: flex;
  margin: auto;
  top: 50%;
  left: 50%;
  width: 40px;
  height: 40px;
  background-color: #027840;
  border: 1px solid #fff;
  padding: '15px 10px';
  border-radius: 100%;
  justify-content:center;
  align-items:center;
  user-select: none;
  transform: translate(-50%, -50%);
  cursor: ${(props) => (props.onClick ? 'pointer' : 'default')};
  &:hover {
    z-index: 1;
  }
`;

const Bicon = styled.div`
  ${'' /* display: relative; */}
  margin: auto;
  ${'' /* width: 30px;
  height: 30px; */}
  padding: 4px 0px;
  ${'' /* border: 0px solid white; */}
  border-radius: 100%;
  ${'' /* background-color: #ffffff; */}
  vertical-align: middle;
  align-items:center;
  justify-content:center;
  text-align:center; 
`;
const Options = styled.div`
  top: 0px;
  left: 0px;
  width: 340px;
  ${'' /* height: 170px; */}
  background:#fff;
  backdrop-filter: blur( 3.5px );
  -webkit-backdrop-filter: blur( 3.5px );
  ${'' /* border-radius: 5px; */}
  ${'' /* border: 1px solid rgba( 255, 255, 255, 0.18 ); */}
  transition: all 1s ease;
  position: absolute;
  padding: 10px;
  ${'' /* transform: translate3d(0px, -116px, 0px); */}
`;

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <a
    href="#"
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >

    {children}
  </a>
));
const Marker = (props) => {
  // console.log(props)
  const { text } = props
  const [isShown, setIsShown] = useState(false);
  // const [isDetail, setIsDetail] = useState(false);

  // console.log(text)
  const gotoFullreport = () => {
    history.push(`/beacons-location-detail/${text._id}`)
    history.go(0)
  }
  return (
    <>
      <Wrapper
        alt={text.name}
        onClick={()=>props.onClick(text)}
        text={text}
        onMouseEnter={() => setIsShown(true) || console.log(isShown)}
        onMouseLeave={() => setIsShown(false) || console.log(isShown)}

      >
        <Bicon>
          {/* <img width="100%" height="100%" alt="" src={icons_beacon} /> */}

          <Dropdown>
            <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components" menuAlign="right">
              <Icon
                className="align-self-center"
                width={30}
                height={30}
                aria-hidden="true"
                icon='BeaconIcon'
                style={{ "color": "#ffffff" }}
              />
            </Dropdown.Toggle>

            <Dropdown.Menu style={{ zIndex: 1000000, width: 250 }} className="text-break text-wrap dropdown-menu-center">
            <span class="dropdown-menu-arrow"></span>
              <Dropdown.Header>
                <div className="d-flex flex-row align-self-center">
                  <div className="">
                    <Icon
                      className="align-self-center text-green"
                      width={18}
                      // height={30}
                      aria-hidden="true"
                      icon='BuildingIcon'
                    /></div>
                  <div className="d-flex align-items-center p-2"><h6 className='text-wrap mb-0'>{text.name}</h6></div>
                </div>
                <p className='text-wrap text-dark'>{text.address}</p>
                <label className='text-uppercase text-muted mb-0'>All Records</label>
                <h5 className='text-warning mb-1 font-weight-light'>{text ? text.times_active.total_amount : ''}</h5>
              </Dropdown.Header>
              <Dropdown.Divider />
              <Dropdown.Header>
                <h6>Beacon Lists</h6>
                {text ? text.times_active.peak_beacons.map((beacons, key) => (
                  <>
                    <ListGroup className='border-0' key={key}>
                      <ListGroup.Item className='border-0 px-0 py-1'>
                        <div className="media d-flex align-items-center">
                          <Icon
                            className="align-self-center text-green"
                            width={24}
                            height={24}
                            aria-hidden="true"
                            icon='BeaconIcon'
                          />
                          <div className="media-body">
                            <p className="mb-0 text-wrap font-weight-bolder text-dark">{beacons.beacon.name} </p>
                            <p className='mb-0'>{beacons.amount} Records</p>
                          </div>
                        </div>
                      </ListGroup.Item>
                    </ListGroup>
                  </>
                )) : ''}
              </Dropdown.Header>
              <Dropdown.Divider />             
              <Dropdown.Item eventKey={10000000} onClick={gotoFullreport}  className="p-0  m-0 text-center text-primary">
                Full report <ArrowForwardIosIcon color='primary'></ArrowForwardIosIcon>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Bicon>


      </Wrapper>
      {isShown && (
        <Options
          onMouseEnter={() => setIsShown(true) || console.log(isShown)}
          onMouseLeave={() => setIsShown(false) || console.log(isShown)}
        >
          <h5>{text.name}</h5>
          <p>{text.address}</p>
        </Options>
      )}
      
    </>
  );
}

Marker.defaultProps = {
  onClick: null,
};

Marker.propTypes = {
  onClick: PropTypes.func,
  text: PropTypes.object.isRequired,
};

export default Marker;